import {
  delete as suprDelete,
  get as suprGet,
  post as suprPost,
  put as suprPut,
} from "superagent";

export const baseUrlFunc = (subdomain: string) => {
  if (process.env.REACT_APP_API_URL === undefined) {
    throw new Error("REACT_APP_API_URL is undefined");
  }
  return process.env.REACT_APP_API_URL.replace("__subdomain__", subdomain); //dev environment
};
export class API {
  readonly baseUrl: URL;

  constructor(subdomain: string, override: boolean = false) {
    this.baseUrl = new URL(!override ? baseUrlFunc(subdomain) : subdomain);
  }

  public post = (url: string) => suprPost(this.baseUrl + url).withCredentials();
  public get = (url: string) => suprGet(this.baseUrl + url).withCredentials();
  public put = (url: string) => suprPut(this.baseUrl + url).withCredentials();
  public delete = (url: string) =>
    suprDelete(this.baseUrl + url).withCredentials();
}
